enum LoginProvider {
    Facebook = 0,
    Google = 1,
    Clubbable = 2,
    Apple = 3
};

export default LoginProvider;